var utero;
(function($) {
  "use strict";
  utero = (function() {
    return {
      init: function() {
        // Header
        this.popupSearch();
        this.sidebarContact();
        this.fixedHeader();
        this.mobileMenu();
        this.sidebarMenu();
        this.canvasCart();
        this.megaMenu();
        this.popupNewsletter();

        // Home default
        this.homeDefaultSlider();
        this.homeDefaultProducts();
        this.homeDefaultFeatures();
        this.homeDefaultPosts();

        // Home modern
        this.homeModernSlider();
        this.homeModernFeatures();
        this.homeModernCategories();

        // Home full width
        this.homeFullWidthFilter();
        this.homeFullWidthLoadCollection();

        // Home collections
        this.homeCollectionsPosts();

        // Home minimal
        this.homeMinimalTestimonials();

        // Collection
        this.collection();
        this.collectionFilter();
        this.newCollectionFilter();
        this.collectionWithSidebar();

        // Product
        this.productForm();
        this.productImages();
        this.productStickyAddToCart();
        this.complementaryProducts();
        this.relatedProducts();
        this.productTabs();
        this.productSizeGuide();
        this.frequentlyBoughtTogether();
        this.askQuestion();

        // Account login
        this.accountLogin();

        // Blog
        this.blogFeaturedArticles();
        this.blogLatestArticles();
        this.blogPagination();

        // Quickview
        this.quickView();
        this.quickViewImages();

        // Wishlist, compare
        this.wishlistPage();
        this.comparePage();

        // Acount pages
        this.accountLogin();

        // Utilities
        this.video();
        this.accordion();
        this.tabs();
        this.quantity();
        this.countDown();
      },

      // Header
      popupSearch: function() {
        $(".js-open-popup-search").on("click", function() {
          $(".js-search-popup").addClass("active");
          return false;
        });
        $(".js-close-search-popup").on("click", function() {
          $(".js-search-popup").removeClass("active");
          return false;
        });
      },

      sidebarContact: function() {
        $(".js-open-sidebar-contact").click(function () {
          $(".js-sidebar-contact").addClass("active");
          return false;
        });
        $(".js-close-sidebar-contact").click(function () {
          $(".js-sidebar-contact").removeClass("active");
          return false;
        });
      },

      fixedHeader: function() {
        if(!$(".js-header").hasClass("stop-hover")) {
          $(window).scroll(function() {
            var scrollTop = $(window).scrollTop();
            if(scrollTop > 50) {
              $(".js-header").addClass("fixed");
            } else {
              $(".js-header").removeClass("fixed");
            }
          });
        }
        $(".js-fixed-header").css("height", $(".js-header").outerHeight());
      },

      mobileMenu: function() {
        $(".js-mobile-megamenu").each(function () {
          var id = $(this).attr("data-id");
          $(".js-second-step-mobile-menu").append($(this));
          $(".js-mobile-menu-item[data-index='" + id + "']").append('<i class="lnil lnil-chevron-right"></i>');
        });
        $(".js-get-previous-menu-title").each(function () {
          var index = $(this).closest(".js-second-step-mobile-menu-item").attr("data-index");
          var title = $(".js-mobile-menu-item[data-index='" + index + "']").attr("data-title");
          $(this).html(title);
        });
        $('.js-mobile-menu-carousel').not('.slick-initialized').slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          arrows: false
        });
        $(".js-mobile-menu-item").click(function () {
          var index = $(this).attr("data-index");
          if($(".js-second-step-mobile-menu-item[data-index='" + index + "']").length > 0) {
            $(".js-second-step-mobile-menu-item").removeClass("active");
            $(".js-second-step-mobile-menu-item[data-index='" + index + "']").addClass("active");
            $(".js-mobile-menu-carousel").slick('slickGoTo', 1);
            return false;
          }
        });
        $(".js-go-to-previous-mobile-menu").click(function () {
          $(".js-mobile-menu-carousel").slick('slickGoTo', 0);
          return false;
        });
        $(".js-open-mobile-menu").click(function () {
          $(".mobile-menu").toggleClass("active");
          $(this).toggleClass("active");
          $(".js-header").toggleClass("with-mobile-menu");
          if($(".mobile-menu").hasClass("active")) {
            $("body").css("overflow", "hidden");
          } else {
            $("body").css("overflow", "visible");
          }
          return false;
        });
      },

      sidebarMenu: function() {
        $(".js-open-sidebar-menu").on("click", function() {
          $(".js-sidebar-menu").addClass("active");
          return false;
        });
        $(".js-close-sidebar-menu").on("click", function() {
          $(".js-sidebar-menu").removeClass("active");
          return false;
        });
      },

      canvasCart: function() {
        $(".js-open-canvas-cart").on("click", function() {
          $(".js-canvas-cart").addClass("active");
          return false;
        });
        $(".js-close-canvas-cart").on("click", function() {
          $(".js-canvas-cart").removeClass("active");
          return false;
        });
        $("body").on("click", ".js-change-quantity", function() {
          $(this).addClass("loading");
          var variantId = parseInt($(this).attr("data-variant-id"));
          var quantity = parseInt($(this).attr("data-quantity"));
          var that = $(".js-cart-item[data-variant-id='" + variantId + "']");
          $(".js-cart-item[data-variant-id='" + variantId + "']").each(function () {
            $(this).css("height", $(this).outerHeight());
          });
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: variantId, quantity: quantity },
            success: function(response) {
              var newPrice = response.total_price;
              if(quantity < 1) {
                $(that).addClass("hide-item");
                setTimeout(function () {
                  $(that).addClass("hidden");
                  if(newPrice == 0) {
                    $(".js-canvas-cart, .js-cart-content").addClass("canvas-cart__empty");
                  }
                }, 300);
                setTimeout(function () {
                  $(".js-cart-item.hidden").remove();
                }, 600);
              } else {
                $(that).find(".js-quantity-minus").attr("data-quantity", quantity - 1);
                $(that).find(".js-quantity-plus").attr("data-quantity", quantity + 1);
                $(that).find(".js-quantity-field-input").val(quantity);
                $(that).find(".js-item-quantity").html(quantity);
              }
              $(".js-change-quantity").removeClass("loading");
              $(".js-cart-subtotal").html(Shopify.formatMoney(response.total_price));
              $('.js-cart-counter').html(response.item_count);
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              $(".js-change-quantity").removeClass("loading");
            }
          });
          return false;
        });
      },

      megaMenu: function() {
        $(".js-get-megamenu").each(function () {
          var id = $(this).attr("data-id");
          if($(".js-megamenu[data-id='" + id + "']").length > 0) {
            $(this).append($(".js-megamenu[data-id='" + id + "']").html());
          }
        });
        $(".js-megamenu").remove();
      },

      popupNewsletter: function() {
        if($(".js-newsletter-popup").length > 0 && localStorage.getItem('popup') != 'true') {
          setTimeout(function () {
            $(".js-newsletter-popup").addClass("active");
          }, $(".js-newsletter-popup").attr("data-show-after"));
          $("body").on("click", ".js-close-newsletter-popup", function () {
            $(".js-newsletter-popup").removeClass("active");
            if($(".js-newsletter-popup").attr("data-show-only-once") == 'true') {
              localStorage.setItem('popup', 'true');
            }
            return false;
          });
        }
      },

      // Home default
      homeDefaultSlider: function() {
        $('.js-home-default-slider').not('.slick-initialized').slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          fade: true,
          arrows: false
        });
        setTimeout(function () {
          $('.js-slider-item-content').addClass("active");
        }, 100);
      },

      homeDefaultProducts: function() {
        $('.js-home-products-carousel').each(function () {
          var LargeDesktopProductsPerRow = parseInt($(this).attr("data-large-desktop-products-per-row"));
          var DesktopProductsPerRow = parseInt($(this).attr("data-desktop-products-per-row"));
          var LaptopProductsPerRow = parseInt($(this).attr("data-laptop-products-per-row"));
          var TabletProductsPerRow = parseInt($(this).attr("data-tablet-products-per-row"));
          var MobileProductsPerRow = parseInt($(this).attr("data-mobile-products-per-row"));
          $(this).not('.slick-initialized').slick({
            slidesToShow: LargeDesktopProductsPerRow,
            slidesToScroll: 1,
            dots: true,
            infinite: false,
            adaptiveHeight: true,
            responsive: [
              {
                breakpoint: 1798,
                settings: {
                  slidesToShow: DesktopProductsPerRow
                }
              },
              {
                breakpoint: 1499,
                settings: {
                  slidesToShow: LaptopProductsPerRow
                }
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: TabletProductsPerRow
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: MobileProductsPerRow
                }
              }
            ]
          });
        });
      },

      homeDefaultFeatures: function() {
        $('.js-home-features-carousel').not('.slick-initialized').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1499,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      },

      homeDefaultPosts: function() {
        $('.js-home-blog-carousel').each(function () {
          var LargeDesktopArticlesPerRow = parseInt($(this).attr("data-large-desktop-articles-per-row"));
          var DesktopArticlesPerRow = parseInt($(this).attr("data-desktop-articles-per-row"));
          var LaptopArticlesPerRow = parseInt($(this).attr("data-laptop-articles-per-row"));
          var TabletArticlesPerRow = parseInt($(this).attr("data-tablet-articles-per-row"));
          var MobileArticlesPerRow = parseInt($(this).attr("data-mobile-articles-per-row"));
          $(this).not('.slick-initialized').slick({
            slidesToShow: LargeDesktopArticlesPerRow,
            slidesToScroll: 1,
            dots: true,
            infinite: false,
            adaptiveHeight: true,
            responsive: [
              {
                breakpoint: 1798,
                settings: {
                  slidesToShow: DesktopArticlesPerRow
                }
              },
              {
                breakpoint: 1499,
                settings: {
                  slidesToShow: LaptopArticlesPerRow
                }
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: TabletArticlesPerRow
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: MobileArticlesPerRow
                }
              }
            ]
          });
        });
      },

      // Home modern
      homeModernSlider: function() {
        $('.js-home-modern-slider').not('.slick-initialized').slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          fade: true,
          arrows: true
        });
        setTimeout(function () {
          $('.js-slider-item-content').addClass("active");
        }, 100);
      },

      homeModernFeatures: function() {
        $('.js-home-modern-features-carousel').not('.slick-initialized').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1499,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      },

      homeModernCategories: function() {
        $('.js-home-modern-categories-carousel').each(function () {
          var LargeDesktopCategoriesPerRow = parseInt($(this).attr("data-large-desktop-categories-per-row"));
          var DesktopCategoriesPerRow = parseInt($(this).attr("data-desktop-categories-per-row"));
          var LaptopCategoriesPerRow = parseInt($(this).attr("data-laptop-categories-per-row"));
          var TabletCategoriesPerRow = parseInt($(this).attr("data-tablet-categories-per-row"));
          var MobileCategoriesPerRow = parseInt($(this).attr("data-mobile-categories-per-row"));
          $(this).not('.slick-initialized').slick({
            slidesToShow: LargeDesktopCategoriesPerRow,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: false,
            adaptiveHeight: false,
            responsive: [
              {
                breakpoint: 1798,
                settings: {
                  slidesToShow: DesktopCategoriesPerRow
                }
              },
              {
                breakpoint: 1499,
                settings: {
                  slidesToShow: LaptopCategoriesPerRow
                }
              },
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: TabletCategoriesPerRow
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: MobileCategoriesPerRow
                }
              }
            ]
          });
        });
      },

      // Home full width filter
      homeFullWidthFilter: function() {
        $(".js-open-collection-filter").on("click", function(){
          if($(window).outerWidth() > 991) {
            $(this).toggleClass('active');
            $(".js-top-filter").slideToggle('');
          } else {
            $(".js-open-mobile-filter, .js-close-filter").toggleClass('active');
            $(".js-top-filter").toggleClass('active');
            $("body").toggleClass("overflow-hidden");
            return false;
          }
        });
        $(".js-open-mobile-filter, .js-close-filter").on("click", function(){
          $(".js-open-mobile-filter, .js-close-filter").toggleClass('active');
          $(".js-top-filter").toggleClass('active');
          $("body").toggleClass("overflow-hidden");
          return false;
        });
        if ($(".js-price-slider").length) {
          setTimeout(function () {
            var maxNumber = parseInt($(".js-price-max").attr("max")) + 1;
            $(".js-price-slider").slider({
              range: true,
              min: 0,
              max: maxNumber,
              values: [$(".js-price-min").attr("value"), maxNumber],
              slide: function(event, ui) {
                $(".js-price-slider-value").val(Shopify.formatMoney(ui.values[0] + "00") + " - " + Shopify.formatMoney(ui.values[1] + "00"));
                $(".js-price-min").val(ui.values[0]);
                $(".js-price-max").val(ui.values[1]);
              }
            });
            if($(".js-price-slider-value").length) {
              $(".js-price-slider-value").val(Shopify.formatMoney($(".js-price-slider").slider("values", 0) + "00") + " - " + Shopify.formatMoney($(".js-price-slider").slider("values", 1) + "00"));
            }
          }, 500);
        }
      },

      homeFullWidthLoadCollection: function() {
        if($(".js-load-collection").length > 0) {
          $(".js-load-collection").each(function () {
            var url = $(this).attr("data-collection-url");
            $.ajax({
              url: url,
              type: 'GET'
            }).done(function(data) {
              $(".js-load-collection").remove();
              $('.js-load-collection-content').append($(data).find('.js-collection-content').html());
              utero.homeFullWidthFilter();
              utero.collectionFilter();
              utero.newCollectionFilter();
            })
          });
        }
      },

      // Home collections
      homeCollectionsPosts: function() {
        $('.js-home-collections-blog-carousel').not('.slick-initialized').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1499,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      },

      // Home minimal
      homeMinimalTestimonials: function() {
        $('.js-home-testimonials-carousel').not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          nav: false,
          infinite: false,
          adaptiveHeight: true
        });
        $(".js-testimonial-logo a").click(function () {
          var index = parseInt($(this).closest(".js-testimonial-logo").attr("data-id")) - 1;
          $('.js-home-testimonials-carousel').slick('slickGoTo', index);
          $(".js-testimonial-logo").removeClass("active");
          $(".js-testimonial-logo").eq(index).addClass("active");
          return false;
        });
        $('.js-home-testimonials-carousel').on('swipe', function(event, slick, direction){
          $(".js-testimonial-logo").removeClass("active");
          $(".js-testimonial-logo").eq(slick.currentSlide).addClass("active");
        });
      },

      // Collection
      collection: function() {
        $(window).scroll(function() {
          if($(".js-collection-next-page").length > 0) {
            var scrollTop = $(window).scrollTop();
            if(scrollTop > $(".js-collection-next-page").offset().top - $(window).outerHeight() - 100) { 
              var href = $(".js-collection-next-page").attr("data-href");
              $(".js-collection-pagination").removeClass("js-collection-next-page");
              $.ajax({
                url: href,
                type: 'GET'
              }).done(function(data) {
                $(".js-collection-pagination").remove();
                $('.js-collection-row').append($(data).find('.js-collection-row').html());
              })
            }
          }
        });
        $("body").on("click", ".js-collection-load-more", function () {
          $(this).html($(this).attr("data-loading-text"));
          var href = $(this).attr("data-href");
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $(".js-collection-load-more").closest(".col-12").remove();
            $('.js-collection-row').append($(data).find('.js-collection-row').html());
          })
          return false;
        });
      },

      collectionFilter: function() {
        $(".js-get-view-all-results-button").last().html($(".js-view-all-results-button").html());
        if($(".js-new-filter").length < 1) {
          Shopify.queryParams = {};
          if($(".js-collection-sort-by-2").length > 0) {
            Shopify.queryParams.sort_by = $(".js-collection-sort-by-2 a.active").attr("data-value");
          } else {
            Shopify.queryParams.sort_by = $(".js-collection-sort-by").val();
          }
          var tags = [];
          $("input.tag").each(function () {
            if($(this).is(":checked")) {
              tags.push($(this).attr("value"));
            }
          });
          Shopify.queryParams.constraint = tags.join("+");

          function filterCreateUrl() {
            if(Shopify.queryParams.constraint == '') {
              return $(".js-collection-items").attr("data-url") + "?sort_by=" + Shopify.queryParams.sort_by + "&view=" + $(".js-collection-items").attr("data-view");
            } else {
              return $(".js-collection-items").attr("data-url") + "/" + Shopify.queryParams.constraint + "?sort_by=" + Shopify.queryParams.sort_by + "&view=" + $(".js-collection-items").attr("data-view");
            }
          }

          function filterGetContent(url) {
            $.ajax({
              type: "get",
              url: url,
              beforeSend: function() {
                $(".js-collection").addClass("loading");
                $(".js-open-mobile-filter, .js-close-filter").removeClass('active');
                $(".js-top-filter").removeClass('active');
                $("body").removeClass("overflow-hidden");
              },
              success: function(result) {
                var title = result.match("<title>(.*?)</title>")[1];
                History.pushState({
                  param: Shopify.queryParams
                }, title, url);
                $(".js-collection").html($(result).find(".js-collection").html());
                $(".js-collection").removeClass("loading");
                utero.wishlistPage();
              },
              error: function() {
                $(".js-collection").removeClass("loading");
              }
            })
          }

          $("body").on("click", ".js-view-collection-results", function () {
            var tags = [];
            $("input.tag").each(function () {
              if($(this).is(":checked")) {
                tags.push($(this).attr("value"));
              }
            });
            Shopify.queryParams.constraint = tags.join("+");
            filterGetContent(filterCreateUrl());
            if($(".js-collection-items").length > 0) {
              $("html, body").stop().animate({scrollTop: $(".js-collection-items").offset().top - 120}, 500);
            }
            return false;
          });

          $("body").on("change", ".js-collection-sort-by", function(y) {
            if($(".js-collection-sort-by-2").length > 0) {
              Shopify.queryParams.sort_by = $(".js-collection-sort-by-2 a.active").attr("data-value");
            } else {
              Shopify.queryParams.sort_by = $(".js-collection-sort-by").val();
            }
            filterGetContent(filterCreateUrl());
            return false;
          });

          $("body").on("click", ".js-collection-sort-by-2 a", function(y) {
            $(".js-collection-sort-by-2 a").removeClass("active");
            $(this).addClass("active");
            if($(".js-collection-sort-by-2").length > 0) {
              Shopify.queryParams.sort_by = $(".js-collection-sort-by-2 a.active").attr("data-value");
            } else {
              Shopify.queryParams.sort_by = $(".js-collection-sort-by").val();
            }
            filterGetContent(filterCreateUrl());
            return false;
          });
        }
      },

      newCollectionFilter: function() {
        if($(".js-new-filter").length > 0) {
          function renderPage(searchParams, event, counter) {
            $(".js-open-mobile-filter, .js-close-filter").removeClass('active');
            $(".js-top-filter").removeClass('active');
            $("body").removeClass("overflow-hidden");
            $(".js-filter").each(function () {
              var section_id = $(this).attr("data-section-id");
              if($(".js-collection-sort-by-2").length > 0) {
                var sort_by = $(".js-collection-sort-by-2 a.active").attr("data-value");
              } else {
                var sort_by = $(".js-collection-sort-by").val();
              }
              var view = $(".js-collection-items").attr("data-view");
              const url = `${window.location.pathname}?section_id=${section_id}&${searchParams}&sort_by=${sort_by}&view=${view}`;
              const filterDataUrl = element => element.url === url;
              fetch(url)
                .then(response => response.text())
                .then((html) => {
                  $(".js-collection").html($(html).find(".js-collection").html());
                  $(".js-collection").removeClass("loading");
                  history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}&sort_by=${sort_by}&view=${view}`);
                  utero.wishlistPage();
                });
            });
          }
          $("body").on("change", ".js-collection-sort-by", function(y) {
            event.preventDefault();
            const formData = new FormData(event.target.closest('form'));
            const searchParams = new URLSearchParams(formData).toString();
            renderPage(searchParams, event, i);
            $(".js-collection").addClass("loading");
            return false;
          });
          $("body").on("click", ".js-collection-sort-by-2 a", function(y) {
            $(".js-collection-sort-by-2 a").removeClass("active");
            $(this).addClass("active");
            event.preventDefault();
            const formData = new FormData(event.target.closest('form'));
            const searchParams = new URLSearchParams(formData).toString();
            renderPage(searchParams, event, i);
            $(".js-collection").addClass("loading");
            return false;
          });
          $(document.body).on('click', '.js-view-collection-results', function(event) {
            if($(".js-collection-items").length > 0) {
              $("html, body").stop().animate({scrollTop: $(".js-collection-items").offset().top - 120}, 500);
            }
            event.preventDefault();
            const formData = new FormData(event.target.closest('form'));
            const searchParams = new URLSearchParams(formData).toString();
            renderPage(searchParams, event, i);
            $(".js-collection").addClass("loading");
            return false;
          });
        }
      },

      collectionWithSidebar: function() {
        if($(".js-collection-with-sidebar").length > 0) {
          var htmlCode = '<div class="collection__top-filter clearfix">';
          htmlCode += $(".js-collection-top-filter-block").html();
          htmlCode += '</div>';
          $(".js-collection-top-filter-block").remove();
          $(".js-get-collection-top-filter").html(htmlCode);
          $(".js-get-collection-top-filter").find(".top-filter__button").remove();
          if($(".js-widget-collections").length > 0) {
            htmlCode = $(".js-widget-collections").html();
            $(".js-get-filter-collections").html(htmlCode);
          } else {
            $(".js-get-filter-collections").closest(".col-12").remove();
          }
          if($(".js-get-filter-content").length > 0) {
            htmlCode = '';
            $(".js-top-filter-widget").each(function () {
              htmlCode += '<div class="col-12 col-md-6 col-lg-25">' + $(this).parent().html() + '</div>';
            });
            $(".js-get-filter-content").html(htmlCode);
          } else {
            $(".js-get-filter-content").remove();
          }
          $(".js-left-sidebar-content").removeClass("d-none");
          $(".container > .js-top-filter").remove();
          if($(".js-filter").length > 0) {
            var id = $(".js-filter").attr("data-section-id");
            $(".js-filter").remove();
            $(".js-get-filter-content").wrapAll("<form class='js-filter' data-section-id='" + id + "' />");
          }
        }
      },

      // Product
      productForm: function() {
        function variants(productId) {
          var data = JSON.parse(document.getElementById('ProductJson' + productId + '').innerHTML);
          var selectCallback = function(variant, selector) {
            var that = $(".js-product[data-product-id='" + productId + "']");
            if (variant) {
              if (variant.available) {
                $(".js-product-action, .js-quantity-option").removeClass("d-none");
                $(".js-product-out-of-stock").addClass("d-none");
              } else {
                $(".js-product-action, .js-quantity-option").addClass("d-none");
                $(".js-product-out-of-stock").removeClass("d-none");
              }
              $(that).find(".js-product-sku").html(variant.sku);
              if(variant.compare_at_price > variant.price) {
                $(that).find(".js-price-old").removeClass("d-none").html(Shopify.formatMoney(variant.compare_at_price));
                $(that).find(".js-price-new").removeClass("d-none").html(Shopify.formatMoney(variant.price));
                $(that).find(".js-price-default").addClass("d-none");
              } else {
                $(that).find(".js-price-old, .js-price-new").addClass("d-none")
                $(that).find(".js-price-default").removeClass("d-none").html(Shopify.formatMoney(variant.price));
              }
              if(typeof(variant.featured_media) != "undefined" && variant.featured_media !== null) {
                if($(".js-product-images-carousel").length > 0) {
                  $(that).find(".js-product-images-carousel").slick('slickGoTo', variant.featured_media.position - 1);
                }
                if($(".js-product-mobile-gallery").length > 0 && $(window).outerWidth() < 992) {
                  $(that).find(".js-product-mobile-gallery").slick('slickGoTo', variant.featured_media.position - 1);
                }
              }
            }
            $(".js-product-size").each(function () {
              var soldOut = true;
              var value = $(this).attr("data-value");
              $(".js-product[data-product-id='" + productId + "'] select[name='id'] option").each(function () {
                if($(this).attr("data-option-1") == value || $(this).attr("data-option-2") == value || $(this).attr("data-option-3") == value) {
                  if($(this).attr("disabled") != "disabled") {
                    soldOut = false;
                  }
                }
              });
              if(soldOut == true) {
                $(this).addClass("out-of-stock");
              } else {
                $(this).removeClass("out-of-stock");
              }
            });
          }
          jQuery(function($) {
            if($("#product-select-" + productId + "").length > 0) {
              new Shopify.OptionSelectors("product-select-" + productId + "", { product: data , onVariantSelected: selectCallback, enableHistoryState: true });
            }
          });
        }

        $(".js-product:not(.active)").each(function () {
          variants($(this).attr("data-product-id"));
          $(this).addClass("active");
        });

        $("body").on("click", ".js-notify-me-button", function () {
          $(this).parent().find("div button").click();
          return false;
        });

        $(".js-product-select").on("change", function () {
          var option = $(this).attr("data-option");
          var value = $(this).val();
          var productId = $(this).attr("data-product-id");
          $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
          return false;
        });

        $(".js-product-color, .js-product-size, .js-product-value").click(function () {
          if($(this).hasClass("js-product-size") || $(this).hasClass("js-product-value")) {
            $(this).parent().parent().find("li a").removeClass("active");
            $(this).addClass("active");
          } else {
            $(this).parent().parent().find("li p").removeClass("active");
            $(this).parent().find("p").addClass("active");
          }
          var option = $(this).parent().parent().attr("data-option");
          var value = $(this).attr("data-value");
          var productId = $(this).attr("data-product-id");
          $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
          $(".js-product[data-product-id='" + productId + "'] .js-product-option-value[data-option='" + option + "']").html(value);
          return false;
        });

        $("body").on("click", ".js-buy-now", function () {
          $(".js-product-form-buy-now button").eq(0).click();
          return false;
        });

        $("body").on("click", ".js-add-to-cart", function () {
          $(this).html($(this).attr("data-adding-text"));
          if($(this).hasClass("variant")) {
            var quantity = 1;
            var id = $(this).attr("data-variant-id");
            var properties = {};
          } else {
            var productId = $(this).attr("data-product-id");
            var quantity = $(".js-product[data-product-id='" + productId + "'] .js-quantity-field").val();
            if(isNaN(quantity) || quantity < 1) { quantity = 1; }
            var id = $(".js-product[data-product-id='" + productId + "'] #product-select-" + productId + "").val();
            var properties = {};
            $(".js-product[data-product-id='" + productId + "'] input, .js-product[data-product-id='" + productId + "'] select, .js-product[data-product-id='" + productId + "'] textarea").each(function () {
              var getName = $(this).attr("name");
              if(typeof getName !== 'undefined') {
                if(getName.indexOf("properties") >= 0) {
                  var name = $(this).attr("name").replace("properties[", "").replace("]", "");
                  var value = $(this).val();
                  properties[name] = value;
                }
              }
            });
          }
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity, properties: properties },
            success: function(response) {
              $(".js-quickview").removeClass("active");

              // Add product cart
              var variant_id = response.variant_id;
              if($(".js-cart-item[data-variant-id='" + variant_id + "']:not(.hidden)").length > 0) {
                var quantity = response.quantity;
                $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-quantity-minus").attr("data-quantity", quantity - 1);
                $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-quantity-plus").attr("data-quantity", quantity + 1);
                $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-quantity-field-input").val(quantity);
                $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-item-quantity").html(quantity);
              } else {
                var quantity_minus = response.quantity - 1;
                var quantity_plus = response.quantity + 1;
                var item = '<li class="cart-item d-flex js-cart-item" data-variant-id="' + response.variant_id + '">';
                item += '<p class="cart-item__image">';
                item += '<a href="' + response.url + '">';
                item += '<img alt="Image" data-sizes="auto" data-srcset="' + response.image + ' 400w" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload lazy-effect">';
                item += '</a>';
                item += '</p>';
                item += '<p class="cart-item__details">';
                item += '<a href="' + response.url + '" class="cart-item__title">' + response.product_title + '</a>';
                if(response.variant_title != 'Default Title' && response.variant_title != null) {
                  item += '<span class="cart-item__variant">' + response.variant_title + '</span>';
                }
                item += '<span class="cart-ietm__price"><u class="js-item-quantity">' + response.quantity + '</u> <i>x</i> ' + Shopify.formatMoney(response.price) + '</span>';
                item += '</p>';
                item += '<div class="cart-item__quantity">';
                item += '<div class="cart-product__quantity-field">';
                item += '<div class="quantity-field__minus"><a href="#" class="js-change-quantity js-quantity-minus" data-variant-id="' + response.variant_id + '" data-quantity="' + quantity_minus + '">-</a></div>';
                item += '<input type="text" value="' + response.quantity + '" class="quantity-field__input js-quantity-field-input" disabled="disabled" />';
                item += '<div class="quantity-field__plus"><a href="#" class="js-change-quantity js-quantity-plus" data-variant-id="' + response.variant_id + '" data-quantity="' + quantity_plus + '">+</a></div>';
                item += '</div>';
                item += '</div>';
                item += '<p class="cart-item__delete">';
                item += '<a href="#" class="js-change-quantity" data-variant-id="' + response.variant_id + '" data-quantity="0"><i class="lnil lnil-close"></i></a>';
                item += '</p>';
                item += '</li>';
                $(".js-cart-items").append(item);
                setTimeout(function () {
                  $(".js-cart-item").removeClass("first-show");
                }, 100);
              }

              // Get cart
              jQuery.getJSON('/cart.js', function(cart) {
                $(".js-canvas-cart, .js-cart-content").addClass("active").removeClass("canvas-cart__empty");
                $(".js-add-to-cart").each(function () {
                  $(this).html($(this).attr("data-original-text"));
                });
                $(".js-cart-subtotal").html(Shopify.formatMoney(cart.total_price));
                $(".js-cart-counter").html(cart.item_count);
              });
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              $(".js-add-to-cart").each(function () {
                $(this).html($(this).attr("data-original-text"));
              });
            }
          });
          return false;
        });
      },

      productImages: function() {
        if($(".js-product-layout-1").length > 0) {
          $(".js-product-thumbnails-carousel").not('.slick-initialized').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            focusOnSelect: true,
            vertical: true,
          });
          $(".js-product-thumbnails-carousel a").click(function (e) {
            var index = $(this).attr("data-index");
            $('body, html').animate({ scrollTop: $(".js-product-image[data-index='" + index + "']").offset().top - 120, }, 300);
            e.preventDefault();
          });
        } else {
          $(".js-product-images-carousel").not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            fade: false,
            infinite: false,
            asNavFor: ".js-product-thumbnails-carousel",
          });
          if($(".js-product-thumbnails-carousel").hasClass("horizontal")) {
            $(".js-product-thumbnails-carousel").not('.slick-initialized').slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              asNavFor: ".js-product-images-carousel",
              dots: false,
              arrows: true,
              focusOnSelect: true,
              infinite: false,
              responsive: [
                {
                  breakpoint: 1499,
                  settings: {
                    slidesToShow: 4
                  }
                },
                {
                  breakpoint: 1198,
                  settings: {
                    slidesToShow: 3
                  }
                },
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 5
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 4
                  }
                }
              ]
            });
          } else {
            $(".js-product-thumbnails-carousel").not('.slick-initialized').slick({
              slidesToShow: 5,
              slidesToScroll: 1,
              asNavFor: ".js-product-images-carousel",
              dots: false,
              arrows: true,
              focusOnSelect: true,
              vertical: true,
            });
          }
          $(".js-product-thumbnails-carousel a").click(function (e) {
            e.preventDefault();
          });
        }
        if($(window).outerWidth() < 992) {
          $(".js-product-mobile-gallery").not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            fade: false,
            infinite: false,
          });
        }
        $(".js-popup-gallery a").jqPhotoSwipe({
          forceSingleGallery: true
        });
      },

      productStickyAddToCart: function() {
        if($(".js-product-action").length > 0) {
          $(window).scroll(function() {
            var scrollTop = $(window).scrollTop();
            if(scrollTop > $(".js-product-action").offset().top + $(".js-product-action").outerHeight()) { 
              $(".js-sticky-add-to-cart").addClass("active");
            } else {
              $(".js-sticky-add-to-cart").removeClass("active");
            }
          });
        }
      },

      complementaryProducts: function() {
        if($(".js-complementary-products").length > 0) {
          var url = $(".js-complementary-products").attr("data-url");

          fetch(url)
            .then(response => response.text())
            .then(text => {
              var html = document.createElement('div');
              html.innerHTML = text;
              var recommendations = html.querySelector('.js-complementary-products');
              $(".js-complementary-products").html(recommendations.innerHTML);
              utero.homeDefaultProducts();
            })
            .catch(e => {
              console.error(e);
            });
        }
      },

      relatedProducts: function() {
        if($(".js-related-products").length > 0) {
          var url = $(".js-related-products").attr("data-url");

          fetch(url)
            .then(response => response.text())
            .then(text => {
              var html = document.createElement('div');
              html.innerHTML = text;
              var recommendations = html.querySelector('.js-related-products');
              $(".js-related-products").html(recommendations.innerHTML);
              utero.homeDefaultProducts();
            })
            .catch(e => {
              console.error(e);
            });
        }
      },

      productTabs: function() {
        if($(".js-get-default-product-tabs").length > 0 && $(".js-default-product-tabs").length > 0) {
          $(".js-get-default-product-tabs").html($(".js-default-product-tabs").html());
          $(".d-none.js-default-product-tabs").remove();
        }
      },

      productSizeGuide: function() {
        $("body").on("click", ".js-get-size-guide a", function () {
          $(".js-size-guide").addClass("active");
          return false;
        });
        $("body").on("click", ".js-close-size-guide", function () {
          $(".js-size-guide").removeClass("active");
          return false;
        })
      },

      frequentlyBoughtTogether: function() {
        $("body").on("click", ".js-add-all-to-cart", function () {
          $(this).html($(this).attr("data-adding-text"));
          var items = [];
          $(".js-frequently-bought-together-product").each(function () {
            if($(this).is(":checked")) {
              var product = {'id': $(this).attr("data-variant-id"), 'quantity': 1};
              items.push(product);
            }
          })
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { items: items },
            success: function(response) {
              for(var product in response.items) {
                // Add product cart
                var variant_id = response.items[product].variant_id;
                if($(".js-cart-item[data-variant-id='" + variant_id + "']:not(.hidden)").length > 0) {
                  var quantity = response.items[product].quantity;
                  $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-quantity-minus").attr("data-quantity", quantity - 1);
                  $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-quantity-plus").attr("data-quantity", quantity + 1);
                  $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-quantity-field-input").val(quantity);
                  $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-item-quantity").html(quantity);
                } else {
                  var quantity_minus = response.items[product].quantity - 1;
                  var quantity_plus = response.items[product].quantity + 1;
                  var item = '<li class="cart-item d-flex js-cart-item" data-variant-id="' + response.items[product].variant_id + '">';
                  item += '<p class="cart-item__image">';
                  item += '<a href="' + response.items[product].url + '">';
                  item += '<img alt="Image" data-sizes="auto" data-srcset="' + response.items[product].image + ' 400w" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload lazy-effect">';
                  item += '</a>';
                  item += '</p>';
                  item += '<p class="cart-item__details">';
                  item += '<a href="' + response.items[product].url + '" class="cart-item__title">' + response.items[product].product_title + '</a>';
                  if(response.items[product].variant_title != 'Default Title' && response.items[product].variant_title != null) {
                    item += '<span class="cart-item__variant">' + response.items[product].variant_title + '</span>';
                  }
                  item += '<span class="cart-ietm__price"><u class="js-item-quantity">' + response.items[product].quantity + '</u> <i>x</i> ' + Shopify.formatMoney(response.items[product].price) + '</span>';
                  item += '</p>';
                  item += '<div class="cart-item__quantity">';
                  item += '<div class="cart-product__quantity-field">';
                  item += '<div class="quantity-field__minus"><a href="#" class="js-change-quantity js-quantity-minus" data-variant-id="' + response.items[product].variant_id + '" data-quantity="' + quantity_minus + '">-</a></div>';
                  item += '<input type="text" value="' + response.items[product].quantity + '" class="quantity-field__input js-quantity-field-input" disabled="disabled" />';
                  item += '<div class="quantity-field__plus"><a href="#" class="js-change-quantity js-quantity-plus" data-variant-id="' + response.items[product].variant_id + '" data-quantity="' + quantity_plus + '">+</a></div>';
                  item += '</div>';
                  item += '</div>';
                  item += '<p class="cart-item__delete">';
                  item += '<a href="#" class="js-change-quantity" data-variant-id="' + response.items[product].variant_id + '" data-quantity="0"><i class="lnil lnil-close"></i></a>';
                  item += '</p>';
                  item += '</li>';
                  $(".js-cart-items").append(item);
                  setTimeout(function () {
                    $(".js-cart-item").removeClass("first-show");
                  }, 100);
                }
              }

              // Get cart
              jQuery.getJSON('/cart.js', function(cart) {
                $(".js-canvas-cart, .js-cart-content").addClass("active").removeClass("canvas-cart__empty");
                $(".js-add-all-to-cart").each(function () {
                  $(this).html($(this).attr("data-original-text"));
                });
                $(".js-cart-subtotal").html(Shopify.formatMoney(cart.total_price));
                $(".js-cart-counter").html(cart.item_count);
              });
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              $(".js-add-all-to-cart").each(function () {
                $(this).html($(this).attr("data-original-text"));
              });
            }
          });
          return false;
        });
        $("body").on("click", ".js-add-all-to-wishlist", function () {
          if(!$(this).hasClass("added")) {
            $(this).addClass("added");
            $(this).html($(this).attr("data-added"));
            $(".js-frequently-bought-together-product").each(function () {
              var productHandle = $(this).attr("data-product-handle");
              var getWishlistProducts = localStorage.getItem('wishlist');
              if(getWishlistProducts == null) { getWishlistProducts = ''; }
              getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
              localStorage.setItem('wishlist', getWishlistProducts + productHandle + ",");
            });
            return false;
          }
        });
      },

      askQuestion: function() {
        $("body").on("click", ".js-ask-question", function () {
          var value = $(this).parent().parent().find(".js-ask-question-body").val();
          value += '\n\nProduct: ' + $(".js-product-title").html();
          $(this).parent().parent().find(".js-ask-question-body").val(value);
        });
      },

      // Account
      accountLogin: function() {
        $(".js-login-forgot-password").on("click", function() {
          $(".js-login-in").removeClass("active");
          $(".js-forgot-password").addClass("active");
          return false;
        });
        $(".js-login-back").on("click", function() {
          $(".js-login-in").addClass("active");
          $(".js-forgot-password").removeClass("active");
          return false;
        });
      },

      // Blog
      blogFeaturedArticles: function() {
        $(".js-featured-articles").not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          fade: false,
          infinite: false,
        });
        $('.js-full-width-featured-articles').not('.slick-initialized').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          infinite: false,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1499,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      },

      blogLatestArticles: function() {
        $('.js-latest-articles-carousel').not('.slick-initialized').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1499,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
        $('.js-latest-articles-2-carousel').not('.slick-initialized').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1499,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      },

      blogPagination: function() {
        $("body").on("click", ".js-blog-next-page", function () {
          var href = $(this).attr("data-href");
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $(".js-blog-load-more").remove();
            $('.js-blog-row').append($(data).find('.js-blog-row').html());
            $('.js-blog-wrap-load-more').append($(data).find('.js-blog-wrap-load-more').html());
          })
          return false;
        });
      },

      // Quickview
      quickView: function() {
        $("body").on("click", ".js-open-quickview", function () {
          $(this).html($(this).attr("data-loading-text"));
          var productUrl = $(this).attr("data-product-url");
          $('.js-get-quickview-content').load(productUrl + ' #quickview-content', function() {
            utero.quickViewImages();
            utero.productForm();
            utero.productImages();
            $(".js-quickview").addClass("active");
            $(".js-open-quickview").each(function () {
              $(this).html($(this).attr("data-original-text"));
            });
          });
          return false;
        });
        $("body").on("click", ".js-close-quickview", function () {
          $(".js-quickview").removeClass("active");
          return false;
        });
      },

      quickViewImages: function() {
        $(".js-quickview-images-carousel").not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          fade: false,
          infinite: false,
        });
      },

      // Wishlist, compare
      wishlistPage: function() {
        $(".js-add-to-wishlist").each(function () {
          var productHandle = $(this).attr("data-product-handle") + ",";
          var wishlist = localStorage.getItem('wishlist');
          if(wishlist == null) { wishlist = ''; }
          if(wishlist.indexOf(productHandle) >= 0) {
            $(this).find("i").attr("class", "lnil lnil-heart-filled");
            $(this).find("span").html($(this).attr("data-added"));
          }
        });
        $("body").on("click", ".js-add-to-wishlist", function () {
          if(!$(this).find("i").hasClass("lnil-heart-filled")) {
            var productHandle = $(this).attr("data-product-handle");
            $(this).find("i").attr("class", "lnil lnil-heart-filled");
            $(this).find("span").html($(this).attr("data-added"));
            var getWishlistProducts = localStorage.getItem('wishlist');
            if(getWishlistProducts == null) { getWishlistProducts = ''; }
            getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
            localStorage.setItem('wishlist', getWishlistProducts + productHandle + ",");
            return false;
          }
        });
        if($(".js-wishlist-body").length > 0) {
          var wishlist = localStorage.getItem('wishlist');
          var wishlistContent = '';
          if(wishlist == null) { wishlist = ''; }
          if(wishlist != '') {
            var wishlistProducts = wishlist.split(",");
            for (let i = 0; i < wishlistProducts.length; i++) {
              if(wishlistProducts[i] != '') {
                jQuery.getJSON('/products/' + wishlistProducts[i] + '.js', function (product) {
                  var first_column = '<td><div class="wishlist__product"><div class="wishlist-product__image"><a href="' + product.url + '"><img alt="Image" data-sizes="auto" data-srcset="' + product.featured_image + ' 400w" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" /></a></div><h3 class="wishlist-product__title"><a href="' + product.url + '">' + product.title + '</a></h3></div></td>';
                  var second_column = '<td><div class="wishlist-product__price">' + Shopify.formatMoney(product.price) + '</div></td>';
                  if(product.available) {
                    var third_column = '<td><div class="wishlist-product__status wishlist-product__status--in-stock">' + $(".js-wishlist-body").attr("data-in-stock") + '</div></td>';
                  } else {
                    var third_column = '<td><div class="wishlist-product__status wishlist-product__status--stock-out">' + $(".js-wishlist-body").attr("data-out-of-stock") + '</div></td>';
                  }
                  var fourth_column = '<td><a href="' + product.url + '" class="fourth-button">' + $(".js-wishlist-body").attr("data-add-to-cart") + '</a></td>';
                  var fifth_column = '<td><div class="wishlist-product__delete"><a href="#" class="js-delete-product-wishlist" data-product-handle="' + product.handle + '"><i class="lnil lnil-close"></i></a></div></td>';
                  wishlistContent = wishlistContent + '<tr>' + first_column + '' + second_column + '' + third_column + '' + fourth_column + '' + fifth_column + '</tr>';
                });
              }
            }
          }
          setTimeout(function () {
            if(wishlistContent == '') {
              wishlistContent = '<tr><td colspan="5">' + $(".js-wishlist-body").attr("data-wishlist-empty") + '</td></tr>';
              $(".js-wishlist-body").html(wishlistContent);
            } else {
              $(".js-wishlist-body").html(wishlistContent);
            }
          }, 1000);
          $("body").on("click", ".js-delete-product-wishlist", function() {
            $(this).parent().parent().parent().remove();
            var productHandle = $(this).attr("data-product-handle");
            var getWishlistProducts = localStorage.getItem('wishlist');
            if(getWishlistProducts == null) { getWishlistProducts = ''; }
            getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
            localStorage.setItem('wishlist', getWishlistProducts);
            return false;
          });
        }
        var wishlist = localStorage.getItem('wishlist');
        if(wishlist == null) { wishlist = ''; }
        var wishlistCounter = wishlist.split(",").length - 1;
        if(wishlistCounter < 0) { wishlistCounter = 0; }
        $(".js-wishlist-count").html(wishlistCounter);
      },

      comparePage: function() {
        $(".js-add-to-compare").each(function () {
          var productHandle = $(this).attr("data-product-handle") + ",";
          var compare = localStorage.getItem('compare');
          if(compare == null) { compare = ''; }
          if(compare.indexOf(productHandle) >= 0) {
            $(this).addClass("compared");
            $(this).find("span").html($(this).attr("data-added"));
          }
        });
        $("body").on("click", ".js-add-to-compare", function () {
          if(!$(this).hasClass("compared")) {
            var productHandle = $(this).attr("data-product-handle");
            $(this).find("span").html($(this).attr("data-added"));
            var getComparedProducts = localStorage.getItem('compare');
            if(getComparedProducts == null) { getComparedProducts = ''; }
            getComparedProducts = getComparedProducts.replace(productHandle + ",", "");
            localStorage.setItem('compare', getComparedProducts + productHandle + ",");
            $(this).addClass("compared");
            return false;
          }
        });
        if($(".js-compare-body").length > 0) {
          var compare = localStorage.getItem('compare');
          var compareContent = '';
          if(compare == null) { compare = ''; }
          if(compare != '') {
            var compareProducts = compare.split(",");
            for (let i = 0; i < compareProducts.length; i++) {
              if(compareProducts[i] != '') {
                jQuery.getJSON('/products/' + compareProducts[i] + '.js', function (product) {
                  var first_column = '<td><div class="wishlist__product"><div class="wishlist-product__image"><a href="' + product.url + '"><img alt="Image" data-sizes="auto" data-srcset="' + product.featured_image + ' 400w" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" /></a></div><h3 class="wishlist-product__title"><a href="' + product.url + '">' + product.title + '</a></h3></div></td>';
                  var second_column = '<td><div class="wishlist-product__price">' + Shopify.formatMoney(product.price) + '</div></td>';
                  if(product.available) {
                    var third_column = '<td><div class="wishlist-product__status wishlist-product__status--in-stock">' + $(".js-compare-body").attr("data-in-stock") + '</div></td>';
                  } else {
                    var third_column = '<td><div class="wishlist-product__status wishlist-product__status--stock-out">' + $(".js-compare-body").attr("data-out-of-stock") + '</div></td>';
                  }
                  var fourth_column = '<td><a href="' + product.url + '" class="fourth-button">' + $(".js-compare-body").attr("data-add-to-cart") + '</a></td>';
                  var fifth_column = '<td><div class="wishlist-product__delete"><a href="#" class="js-delete-product-compare" data-product-handle="' + product.handle + '"><i class="lnil lnil-close"></i></a></div></td>';
                  compareContent = compareContent + '<tr>' + first_column + '' + second_column + '' + third_column + '' + fourth_column + '' + fifth_column + '</tr>';
                });
              }
            }
          }
          setTimeout(function () {
            if(compareContent == '') {
              compareContent = '<tr><td colspan="5">' + $(".js-compare-body").attr("data-compare-empty") + '</td></tr>';
              $(".js-compare-body").html(compareContent);
            } else {
              $(".js-compare-body").html(compareContent);
            }
          }, 1000);
          $("body").on("click", ".js-delete-product-compare", function() {
            $(this).parent().parent().parent().remove();
            var productHandle = $(this).attr("data-product-handle");
            var getCompareProducts = localStorage.getItem('compare');
            if(getCompareProducts == null) { getCompareProducts = ''; }
            getCompareProducts = getCompareProducts.replace(productHandle + ",", "");
            localStorage.setItem('compare', getCompareProducts);
            return false;
          });
        }
      },

      // Account
      accountLogin: function() {
        $(".js-go-to-forgotten-password").click(function () {
          $(".js-login").addClass("d-none");
          $(".js-forgotten-password").removeClass("d-none");
          return false;
        });
        $(".js-back-to-login").click(function () {
          $(".js-login").removeClass("d-none");
          $(".js-forgotten-password").addClass("d-none");
          return false;
        });
      },

      // Utilities
      video: function() {
        if($('.js-video').length > 0) {
          $(".js-video").each(function () {
            this.controls = false;
            $(this).get(0).play();
          });
        }
      },

      accordion: function() {
        $(".js-accordion-title").on("click", function() {
          $(this).parent().parent().find(".js-accordion").removeClass("current");
          $(this).parent().toggleClass("active").addClass("current");
          $(this).parent().find(".js-accordion-content").slideToggle(500);
        });
        $(".js-accordion.active").each(function () {
          $(this).find(".js-accordion-content").slideToggle(500);
        });
      },

      tabs: function() {
        $(".js-open-tab").on("click", function() {
          var id = $(this).attr("data-id");
          $(".js-tab[data-id='" + id + "']").addClass("active");
          return false;
        });
        $(".js-close-tab").on("click", function() {
          $(".js-tab").removeClass("active");
          return false;
        });
        $(".js-tab-link").on("click", function() {
          $(this).parent().parent().find(".js-tab-link").removeClass("active");
          $(this).addClass("active");
          $(this).parent().parent().parent().find(".js-tab-content").removeClass("tab-content__active").removeClass("tab-content__show");
          var that = $(this).parent().parent().parent().find(".js-tab-content[data-id='" + $(this).attr("data-id") + "']");
          $(that).addClass("tab-content__active");
          setTimeout(function () {
            $(that).addClass("tab-content__show");
          }, 100);
          return false;
        });
      },

      quantity: function() {
        $("body").on("click", ".js-quantity-down", function() {
          var q_val_up = parseInt($(this).parent().find(".js-quantity-field").val());
          if(isNaN(q_val_up)) {
            q_val_up = 0;
          }
          if(q_val_up > 0) {
            $(this).parent().find(".js-quantity-field").val(q_val_up-1).keyup();
          } 
          return false; 
        });
        $("body").on("click", ".js-quantity-up", function() {
          var q_val_up = parseInt($(this).parent().find(".js-quantity-field").val());
          if(isNaN(q_val_up)) {
            q_val_up = 0;
          }
          $(this).parent().find(".js-quantity-field").val(q_val_up+1).keyup(); 
          return false; 
        });
      },

      countDown: function() {
        $(".js-countdown").each(function () {
          var that = $(this);
          setInterval(function () {
            var currentDate = new Date().getTime();
            var deadlineDate = new Date($(that).attr("data-deadline-date")).getTime();
            var distance = deadlineDate - currentDate;
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            $(that).find(".js-countdown-days").html(days);
            $(that).find(".js-countdown-hours").html(hours);
            $(that).find(".js-countdown-minutes").html(minutes);
            $(that).find(".js-countdown-seconds").html(seconds);
          }, 1000);
        });
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  utero.init();
});

if (window.Shopify.designMode) {
  jQuery(document)
    .on('shopify:section:load', function() {
      utero.init();
    }).on('shopify:section:unload', function() {
      utero.init();
    }).on('shopify:section:select', function() {
      utero.init();
    }).on('shopify:section:deselect', function() {
      utero.init();
    }).on('shopify:block:select', function() {
      utero.init();
    }).on('shopify:block:deselect', function() {
      utero.init();
    });
}